import { defineComponent as _defineComponent } from 'vue'
import { LogisticsStep } from '@/modules/Logistics/interfaces/LogisticsInterfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepNavigator',
  props: {
    steps: null,
    showDescriptions: { type: Boolean, default: false },
    allowNavigation: { type: Boolean, default: false }
  },
  emits: ["step-click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'step-click', step: LogisticsStep, index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { steps: LogisticsStep[], showDescriptions: boolean, allowNavigation: boolean };





function handleStepClick(step: LogisticsStep, index: number) {
    if (props.allowNavigation) {
        emit('step-click', step, index);
    }
}

return { __sfc: true,props, emit, handleStepClick }
}

})